import { useQuery } from '@tanstack/react-query';

import type { ProductWebinarReservation } from '~/routes/__loaders/product_webinar_reservation';

export const productWebinarReservationKeys = {
  all: ['product-webinar-reservation'] as const,
  bySlug: (slug: string) => ['product-webinar-reservation', slug] as const,
};

const fetchProductWebinarReservation = async (slug: string): Promise<ProductWebinarReservation> => {
  const response = await fetch(`/product_webinar_reservation?slug=${encodeURIComponent(slug)}`);
  if (!response.ok) throw new Error('Failed to fetch product webinar reservation');
  return response.json();
};

interface Props {
  slug: string;
  enabled?: boolean;
}

const useProductWebinarReservation = ({ slug, enabled = true }: Props) => {
  return useQuery({
    queryKey: productWebinarReservationKeys.bySlug(slug),
    queryFn: () => fetchProductWebinarReservation(slug),
    enabled: enabled && !!slug,
    staleTime: 60_000,
  });
};

export default useProductWebinarReservation;
